import { render, staticRenderFns } from "./CustomSelectTree.vue?vue&type=template&id=06bb0eeb&scoped=true"
import script from "./CustomSelectTree.vue?vue&type=script&lang=js"
export * from "./CustomSelectTree.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bb0eeb",
  null
  
)

export default component.exports